import React from 'react';

import {LanguageSelector} from '@/widgets/LanguageSelector';
import {SubscriptionBanner} from '@/widgets/subscriptionBanner';
import {UserMenu} from '@/widgets/UserMenu';
import {AccountInfo, Separator} from '@features/Account/styled';

export const Account = () => (
    <AccountInfo>
        <SubscriptionBanner />
        <Separator />
        <UserMenu />
        <Separator />
        <LanguageSelector />
    </AccountInfo>
);
